const userColor = state => {
	if (state.auth.permission == '') {
	    return state.color.student;
    }else
    	return state.color[state.auth.permission];
}

export default{
	userColor
}